import React, { forwardRef, memo } from 'react';

import style from './index.module.scss';

import clsx from 'clsx';
import { Chip, ChipProps } from '@mui/material';
import { useIsBelowMd } from 'hooks/use-is-below-md';

interface Props extends Omit<ChipProps, 'children' | 'label'> {
  className?: string;
  children: React.ReactNode;
  priority?: 'medium' | 'high' | 'highest' | 'low';
  /**
   * N2 (T4): the remark's plain text, from a card that opts in. Below md a
   * remark of more than one word is that text with a 3 px start bar in the
   * pill's colour, not a pill (a pill wrapped to two or three lines read as a
   * button); a short single-word status stays a pill. Above md: the pill.
   */
  textBelowMd?: string | null;
}

const isMultiWord = (text: string | null | undefined): text is string =>
  Boolean(text && /\s/.test(text.trim()));

const ShortRemarkComponent = forwardRef<HTMLDivElement, Props>(
  ({ className, priority = 'medium', children, textBelowMd, ...rest }, ref) => {
    const isBelowMd = useIsBelowMd();
    if (isBelowMd && isMultiWord(textBelowMd)) {
      return (
        <div
          ref={ref}
          title={typeof rest.title === 'string' ? rest.title : undefined}
          className={clsx(style.text, style[priority], className)}
        >
          {textBelowMd}
        </div>
      );
    }
    return (
      <Chip
        ref={ref}
        color={'secondary'}
        {...rest}
        size={'small'}
        label={children}
        className={clsx(style.root, className, style[priority])}
      />
    );
  },
);

export const ShortRemark = memo(ShortRemarkComponent) as typeof ShortRemarkComponent;
